'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemIndex;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../styles/ItemIndex.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ItemIndex(_ref) {
  var index = _ref.index;

  return _react2.default.createElement(
    'div',
    { className: 'cp-user-list-item-index', 'data-test-id': 'item-index' },
    index + 1
  );
}

ItemIndex.propTypes = {
  index: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-index/components/ItemIndex.component.js
// module id = 1301
// module chunks = 0